import clsx from 'clsx';
import type { ReactNode } from 'react';

interface ErrorLabelProps {
  children: ReactNode;
  className?: string;
  role?: string;
}

export default function ErrorLabel({ children, className, role }: ErrorLabelProps) {
  const errorLabelClasses = clsx('odin-mt-1 odin-text-xs odin-text-error', className);
  return (
    <span className={errorLabelClasses} role={role}>
      {children}
    </span>
  );
}
